module.exports = __webpack_public_path__ + "static/media/home__banner.75250806.png";